import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router keeps the scroll position between pages; reset it on navigation,
// or jump to the #section when the link includes one.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
